import axios from 'axios';
import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import React, {useState, useEffect} from 'react';
import './Coin.css'

const Coin = ({coins}) => {

  const {paramName} = useParams();
  console.log('params', paramName);
  

  const [coin, setCoin] = useState({});
  const [allCoins, setAllCoins] = useState({});
  const [loading, setLoading] = useState(true);

  // const url = `https://api.coingecko.com/api/v3/coins/${params.coinId}`
  // const url = `http://osdevhub.com/projects/coinsearch/getcoin.php?id=${paramName}`;
  // const url = `https://cors-anywhere.herokuapp.com/https://api.coingecko.com/api/v3/coins/${paramName}?vs_currency=usd&order=market_cap_desc&per_page=10&page=1&sparkline=false&locale=en`;
  // const url = `https://api.allorigins.win/get?url=https://api.coingecko.com/api/v3/coins/${params.coinId}?vs_currency=usd&order=market_cap_desc&per_page=10&page=1&sparkline=false&locale=en`;

  // useEffect(() => {
  //   axios.get(url).then((response) => {
  //     setCoin(response.data);
  
  //     setLoading(false);
  //     console.log('coin', coin);
      
  //   }).catch((error) => {
  //     console.log(error);
  //     setLoading(false)
  //   })
  // }, [url])


    const url = "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=10&page=1&sparkline=false&locale=en"

  useEffect(() => {
    axios.get(url).then((response) => {
      setAllCoins(response.data)
      const filteredCoins = response.data.filter(coin => coin.id === paramName);
      setCoin(filteredCoins[0])
      setLoading(false)
      
      console.log('filtercoins', filteredCoins)
    }).catch((error) => {
      console.log(error)
    })
  }, [])

 

  if (loading) {
    return <h1>{coin.name ? coin.name : 'Loading...'}</h1>;
  }
  

  return (
    <div>
      <div className='coin-container'>
        <div className='content'>
          <h1>{coin.name}</h1>
        </div>
        <div>
          <div className='content'>
            <div className='rank'>
              <span className='rank-btn'> Rank # {coin.market_cap_rank}</span>
            </div>
            <div className='info'>
              <div className='coin-heading'>
                {coin.image ? <img src={coin.image} alt='' /> : " data" } 
                {coin.symbol ? <p>{coin.symbol.toUpperCase()}</p> : " data"}
                {coin.symbol ? <p>{coin.name.toUpperCase()}</p> : " data"}
              </div>
              <div className='coin-price'>
                {coin.current_price? <h1>${coin.current_price.toLocaleString()}</h1> : "data"}
                
              </div>

            </div>

          </div>
        <div className='content'>
          <table>
            <thead>
              <tr>
                <th>24hr</th>
     
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{coin.price_change_percentage_24h ? <p>{coin.price_change_percentage_24h.toFixed(1)}%</p> : "data"}</td>
      
     
     
              </tr>
            </tbody>
          </table>
        </div>
    <div className='content'>
      <div className='stats'>
        <div className='left'>
          <div className='row'>
            <h4>24 Hour Low</h4>
            {coin.low_24h? <p>${coin.low_24h.toLocaleString()}</p> : "data"}
          </div>
          <div className='row'>
            <h4>24 Hour High</h4>
            {coin.high_24h? <p>${coin.high_24h.toLocaleString()}</p> : "data"}
          </div>
        </div>
        <div className='right'>
          <div className='row'>
            <h4>Market Cap</h4>
            {coin.market_cap ? <p>{coin.market_cap.toLocaleString()}</p> : "data"}
          </div>
          <div className='row'>
            <h4>Circulating Supply</h4>
            {coin? <p>{coin.circulating_supply}</p> : "data"}
          </div>
          
        </div>
      </div>
    </div>
      <div className='content'>
        <div className='about'>
          <h3>About</h3>
          <p dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(coin.description ? coin.description.en : "Description")
            }} />


        </div>

      </div>
        </div>
      </div>
    </div>
  )
  
}

export default Coin